//region :: Imports ::
import {isNullOrUndefined, MNullable} from './Utils';

//endregion

/** */
export type MValidationErrorsType = { [key: string]: string[] };

/** */
class MInvokeResult {

    public readonly validationErrors: MNullable<MValidationErrorsType>;
    public readonly exception: MNullable<any>;
    public readonly hasErrors: boolean;

    /** */
    private constructor(validationErrors: MNullable<MValidationErrorsType>, exception: MNullable<any>) {

        this.validationErrors = validationErrors;
        this.exception = exception;
        this.hasErrors = validationErrors !== null;

    }

    /** */
    public static getValidationErrors(exception: any): MNullable<MValidationErrorsType> {

        const validationErrors = exception.response.errors;
        return isNullOrUndefined(validationErrors) ? null : validationErrors;

    };

    /** */
    public static ok(): MInvokeResult {
        return new MInvokeResult(null, null);
    }

    /** */
    public static notOk(exception: any): MInvokeResult {

        const validationErrors = MInvokeResult.getValidationErrors(exception);

        if(validationErrors === null) {
            throw exception;
        }

        return new MInvokeResult(validationErrors, exception);

    }

}

export default MInvokeResult;
